import { BrandConfig } from '../../types/config.types';

export const lazydocConfig: BrandConfig = {
    // ============================================
    // ОСНОВНАЯ ИНФОРМАЦИЯ
    // ============================================
    id: 'lazydoc',
    name: 'LazyDoc',
    description: 'AI Медицинский Помощник',

    // ============================================
    // API И BACKEND
    // ============================================
    apiUrl: 'https://db.lazydoc.su',
    defaultPrompt: 'LD-App-Base',

    // ============================================
    // ЛОГОТИПЫ
    // ============================================
    logos: {
        small: 'lazydoc/logos/small-logo.svg', // 32x32px для закрытого сайдбара
        full: 'lazydoc/logos/full-logo.svg', // 160x24px для открытого сайдбара
        auth: 'lazydoc/logos/full-logo.svg', // 200x30px для страницы авторизации
        favicon: 'lazydoc/favicon.ico',
    },

    // ============================================
    // АНИМАЦИИ
    // ============================================
    animations: {
        splashScreen: 'start.json', // Lottie анимация для сплэш-скрина
    },

    // ============================================
    // ТЕМА
    // ============================================
    theme: {
        /**
         * Цветовая схема синхронизирована с текущими SCSS-переменными:
         * см. src/features/styles/colors-default.scss
         *
         * $primary-color:#ff471e;
         * $secondary-color: #e9f0ff;
         * $background-color:#f4f8ff;
         * $text-color:      #222222;
         */
        primary: '#1E6FFF',
        secondary: '#E9F0FF',
        accent: '#FF4757', // используется как акцентный/ошибочный цвет в UI
        background: '#F4F8FF',
        text: '#222222',
        messageBackground: '#D1E7FF', // фон сообщения пользователя в чате
        cssVariables: {
            '--lazydoc-primary': '#1E6FFF',
            '--lazydoc-secondary': '#E9F0FF',
            '--lazydoc-accent': '#FF4757',
        },
    },

    // ============================================
    // PWA МАНИФЕСТ
    // ============================================
    manifest: {
        name: 'LazyDoc - AI Медицинский Помощник',
        shortName: 'LazyDoc',
        description: 'Интеллектуальный помощник врача для создания медицинских протоколов и документации',
        display: 'standalone',
        startUrl: '/',
        scope: '/',
        orientation: 'portrait',
        backgroundColor: '#F4F8FF',
        themeColor: '#1E6FFF',
        iconsFolder: 'lazydoc',
        updateFavicon: true,
        updateTitle: true,
    },

    // ============================================
    // РЕГИСТРАЦИЯ
    // ============================================
    registration: {
        enabled: true,
    },

    // ============================================
    // ЛОКАЛИЗАЦИЯ
    // ============================================
    i18n: {
        defaultLanguage: 'ru',
        supportedLanguages: ['ru', 'en'],
    },

    // ============================================
    // ДОПОЛНИТЕЛЬНО
    // ============================================
    customSettings: {
        analyticsEnabled: true,
        feedbackEnabled: true,
    },
};